export const useAttributes = async () => {
  const { support, store } = usePim()

  await support.loadAttributes()

  const attributes = computed(() => store.attrs)

  const byIds = computed(() => attributes.value?.allByIds || {})
  const wellKnown = computed(() => attributes.value?.wellKnown || {})

  return {
    byIds,
    wellKnown,
  }
}
